<template>
  <div class="page">
    
    <div class="flex justify-content-center">
      <form>
        <div class="grid">
          <div class="col">
            <label for="from-date">Da&nbsp;</label>
            <calendar id="from-date" 
              v-model="fromDate" 
              :showIcon="true" 

              dateFormat="dd/mm/yy"
            />
          </div>

          <div class="col">
            <label for="to-date">A&nbsp;</label><br>
            <calendar id="to-date" 
              v-model="toDate" 
              :showIcon="true" 

              dateFormat="dd/mm/yy"
            />
          </div>

          <div class="col">
            <i></i><br>
            <prime-button id="search-button" type="submit" icon="pi pi-search" class="p-button-rounded" @click.prevent="onFilter($event)" />
          </div>
        </div>
      </form>
    </div>
    
    <div class="flex justify-content-between flex-wrap">
      <div class="flex">
        <span v-if="((success != null) && (success == false))" style="color: red;">Ci sono stati problemi durante l'aggiornamento</span>
        <span v-if="updated" style="color: green;">Aggiornamento effettuato correttamente</span>
      </div>
      <div class="flex">
        <prime-button id="update-button" label="Segna come non usate" class="mb-auto" @click="onUpdate($event)" :disabled="data_.selected.length == 0" />
      </div>
    </div>

    <data-table 
      :value="data_.letture" 
      v-model:selection="data_.selected"

      dataKey="id" 

      rowGroupMode="rowspan" 
      groupRowsBy="code"

      sortMode="multiple"
      responsiveLayout="scroll" 

      :paginator="true" 
      :rows="10"
      :rowsPerPageOptions="[10,25,50]"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
      currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"  
    >
      <column selectionMode="multiple" headerStyle="width: 3em"></column>
      <column field="code" header="PDR">
        <template #body="{ data }">
          <router-link
            :to="`/ask/pdrs/${data.cod_pdr}/dettagli`"
            custom
            v-slot="{ href }"
          >
            <prime-button 
              :label="`${data.code}`" 
              class="p-button-info p-button-text"
              @click="navigateToTab(href)" 
            />
          </router-link>
        </template>
      </column>

      <column header="Data">
        <template #body="{data}">
          <span>
            {{ (data.data_misura !== null)? moment(data.data_misura).format('DD/MM/YYYY'): '' }} 
          </span>
        </template>
      </column>

      <column header="Consumo">
        <template #body="{data}">
          <span>
            {{ lettureFormatter.format( (data.consumo !== null)? data.consumo: 0 ) }}
          </span>
        </template>
      </column>

      <column header="Coefficente">
        <template #body="{data}">
          <span>
            {{ lettureFormatter.format( (data.coeff !== null)? data.coeff: 0 ) }}
          </span>
        </template>
      </column>

      <column header="Usata">
        <template #body="{data}">
          <span>
            {{ (data.used)? 'SI' : 'NO' }}
          </span>
        </template>
      </column>
      
    </data-table>

  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/letture-pdr-service'

import PrimeButton from 'primevue/button'

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  
  components: {
    PrimeButton
  },

  data() {
    return {
      page:{
        name: 'pdrs-gestione-letture',
      },

      moment,

      lettureFormatter: new Intl.NumberFormat('it-IT', { useGrouping:false, minimumFractionDigits: 6 }),

      success: null,
      updated: false,

      data_: {
        from_date: moment().subtract(1,'months').startOf('month').format('YYYY-MM-DD'),
        to_date: moment().subtract(1,'months').endOf('month').format('YYYY-MM-DD'),

        podIds: this.data,

        letture: [],
        selected: [],
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
  },

  mounted() {
    this.getLetture()
  },

  methods:{

    onCancelButton(){
      this._reset()

      this.$eventBus.emit('dialog-return-cancel-button', {})
    },

    ////

    onFilter(/** event **/){
      this.success = null
      this.updated = false

      this.getLetture()
    },

    onUpdate(/** event **/){
      this.success = null
      this.updated = false

      const ids = this.data_.selected.map((el) => el.id)
      const data = {used: 0}

      this.service.updateMassivo({
        data,
        filters: {
          'lettura.ids': ids
        },
      }).then((res) => {
        if(res.success){
          this.data_.letture = this.data_.letture.filter((el) => this.data_.selected.indexOf(el) < 0)
          this.data_.selected = []

          this.updated = true
        }else{
          this.success = false
        }
      })
    },

    ////

    _reset(){
      this.success = null
      this.updated = false

      this.data_.from_date = moment().subtract(1,'months').startOf('month').format('YYYY-MM-DD'),
      this.data_.to_date = moment().subtract(1,'months').endOf('month').format('YYYY-MM-DD'),

      this.data_.podIds = [] 

      this.data_.letture = []
      this.data_.selected = []
    },

    navigateToTab(href){
      window.open(href, '_blank')
    },

    getLetture(){
      this.service.getLetture({
        "from": this.data_.from_date,
        "to": this.data_.to_date,
        "pod.ids": [...this.data_.podIds]
      }).then((res) => {
        this.data_.letture = res.items
      })
    },
  },

  computed:{
    fromDate: {
      get: function() {
        return (this.data_.from_date !== null && this.data_.from_date !== '')? moment(this.data_.from_date).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.data_.from_date = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.data_.from_date = null
        }
      }
    },

    toDate: {
      get: function() {
        return (this.data_.to_date !== null && this.data_.to_date !== '')? moment(this.data_.to_date).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.data_.to_date = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.data_.to_date = null
        }
      }
    },
  },
}
</script>

<style scoped>
  
</style>
